import { workStepsData } from "@/mocks/landingData";

export default function WorkSteps() {
  return (
    <section id="steps" className="section-padding relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-full bg-gradient-to-b from-transparent via-teal-500/30 to-transparent hidden lg:block" />

      <div className="container-main">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="v2-section-label justify-center">
            <span className="w-8 h-px bg-teal-400" />
            مراحل العمل
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mt-4">
            <span className="title-line-1">من الفكرة إلى الإطلاق</span>
            <span className="title-line-2 v2-gradient-text">في 5 خطوات</span>
          </h2>
        </div>

        <div className="space-y-6 lg:space-y-0 lg:grid lg:grid-cols-5 lg:gap-4">
          {workStepsData.map((step, index) => (
            <article
              key={step.step}
              className="relative v2-glass-card-hover p-6 md:p-8 lg:text-center group"
            >
              <div className="hidden lg:block absolute top-8 left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-teal-400 shadow-[0_0_12px_rgba(45,212,191,0.8)] z-10" />
              <div className="flex lg:flex-col items-start lg:items-center gap-5">
                <div className="relative flex-shrink-0">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-teal-500 to-aait-primary flex items-center justify-center text-xl font-black text-white shadow-[0_0_25px_-5px_rgba(45,212,191,0.6)] group-hover:scale-110 transition-transform">
                    {step.step}
                  </div>
                  {index < workStepsData.length - 1 && (
                    <div className="lg:hidden absolute top-full right-1/2 translate-x-1/2 w-0.5 h-6 bg-teal-500/30" />
                  )}
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-2 group-hover:text-teal-200 transition-colors">
                    {step.title}
                  </h3>
                  <p className="text-sm text-slate-400 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
